<template>
  <div class="mypage-layout">
    <aside class="sidebar">
      <div class="user-info">
        <div class="user-avatar">{{ userProfile?.email?.charAt(0).toUpperCase() || 'U' }}</div>
        <div class="user-detail">
          <p class="user-email">{{ userProfile?.email }}</p>
          <span class="user-role">{{ userProfile?.role === 'admin' ? '관리자' : '일반회원' }}</span>
        </div>
      </div>

      <!-- 포인트 카드 -->
      <router-link to="/mypage/points" class="point-card">
        <div class="point-header">
          <span class="point-label">내 잇포인트</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </div>
        <div class="point-amount">{{ formatPoints(userProfile?.points || 0) }}<span>P</span></div>
        <div class="point-sub">
          <span v-if="userProfile?.referralCode" class="referral-code">
            추천코드: {{ userProfile.referralCode }}
          </span>
        </div>
      </router-link>

      <nav class="sidebar-nav">
        <!-- 포인트 메뉴 그룹 -->
        <div class="nav-group">
          <div class="nav-group-header">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 6v6l4 2"/>
            </svg>
            <span>포인트</span>
          </div>
          <div class="nav-group-items">
            <router-link to="/mypage/points" class="nav-item" active-class="active">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <path d="M10 13l1 1c1 1 2 1 3 0l2-2c1-1 1-2 0-3l-1-1"/>
                <path d="M14 11l-1-1c-1-1-2-1-3 0l-2 2c-1 1-1 2 0 3l1 1"/>
              </svg>
              잇포인트
            </router-link>
            <router-link to="/mypage/store" class="nav-item" active-class="active">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M6 2L3 7v13a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7l-3-5z"/>
                <path d="M3 7h18"/>
                <path d="M16 11a4 4 0 0 1-8 0"/>
              </svg>
              잇스토어
            </router-link>
                        <router-link to="/products" class="nav-item" active-class="active">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
                  <line x1="7" y1="7" x2="7.01" y2="7"/>
                </svg>
              상품안내
            </router-link>
          </div>
        </div>

        <!-- 내 활동 메뉴 그룹 -->
        <div class="nav-group">
          <div class="nav-group-header">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
            </svg>
            <span>내 활동</span>
          </div>
          <div class="nav-group-items">
            <router-link to="/mypage/favorites" class="nav-item" active-class="active">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
              </svg>
              관심 공고
            </router-link>
            <router-link to="/mypage/jobs" class="nav-item" active-class="active">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
              </svg>
              내 공고 관리
            </router-link>
            <router-link to="/mypage/sides" class="nav-item" active-class="active">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
                <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
                <path d="M12 12v4"/>
                <path d="M10 14h4"/>
              </svg>
              내 사이드
            </router-link>
          </div>
        </div>

        <!-- 이벤트 메뉴 그룹 -->
        <div class="nav-group">
          <div class="nav-group-header">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="8" r="6"/>
              <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/>
            </svg>
            <span>이벤트</span>
          </div>
          <div class="nav-group-items">
                        <router-link to="/events" class="nav-item" active-class="active">
<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
  <rect x="3" y="8" width="18" height="13" rx="1"/>
  <path d="M12 8v13"/>
  <path d="M3 12h18"/>
  <path d="M19 8c0-2.5-2-4-4-4-1.5 0-2.5 1-3 2-.5-1-1.5-2-3-2-2 0-4 1.5-4 4"/>
</svg>
              이벤트
            </router-link>
            <router-link to="/mypage/event" class="nav-item" active-class="active">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="2" y="4" width="20" height="16" rx="2"/>
                <path d="M12 8v8"/>
                <path d="M8 12h8"/>
              </svg>
              잇다슬롯
            </router-link>
          </div>
        </div>

        <!-- 고객지원 메뉴 그룹 -->
        <div class="nav-group">
          <div class="nav-group-header">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            </svg>
            <span>고객지원</span>
          </div>
          <div class="nav-group-items">
                                    <router-link to="/notices" class="nav-item" active-class="active">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                  <polyline points="14 2 14 8 20 8"/>
                  <line x1="16" y1="13" x2="8" y2="13"/>
                  <line x1="16" y1="17" x2="8" y2="17"/>
                </svg>
              공지사항
            </router-link>
            <router-link to="/mypage/inquiries" class="nav-item" active-class="active">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                <path d="M8 9h8"/>
                <path d="M8 13h6"/>
              </svg>
              내 문의
            </router-link>
                        <router-link to="/inquiry" class="nav-item" active-class="active">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                </svg>
              이용문의
            </router-link>
                                    <router-link to="/faq" class="nav-item" active-class="active">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M9 9a3 3 0 1 1 4 2.83c-.5.29-1 .87-1 1.5V15"/>
                  <circle cx="12" cy="18" r="0.5" fill="currentColor"/>
                </svg>
              FAQ
            </router-link>
                                                <router-link to="/contact" class="nav-item" active-class="active">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              광고문의
            </router-link>
          </div>
        </div>

        <!-- 설정 메뉴 그룹 -->
        <div class="nav-group">
          <div class="nav-group-header">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="3"/>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
            </svg>
            <span>설정</span>
          </div>
          <div class="nav-group-items">
            <router-link to="/mypage/profile" class="nav-item" active-class="active">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
              내 정보 수정
            </router-link>
          </div>
        </div>
      </nav>

      <div class="inquiry-section">
        <h3 class="inquiry-title">문의하기</h3>
        <a href="http://pf.kakao.com/_your_channel" target="_blank" class="inquiry-btn kakao">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 3C6.48 3 2 6.58 2 11c0 2.8 1.86 5.25 4.64 6.64-.2.75-.73 2.72-.84 3.14-.13.51.19.5.4.37.17-.11 2.64-1.8 3.73-2.53.68.1 1.38.15 2.07.15 5.52 0 10-3.58 10-8 0-4.42-4.48-8-10-8z"/>
          </svg>
          24/7 카카오톡 문의
        </a>
        <a href="mailto:ad@bunyang.com" class="inquiry-btn email">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="2" y="4" width="20" height="16" rx="2"/>
            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
          </svg>
          광고/제휴 문의
        </a>
      </div>

      <div v-if="currentAd" class="sidebar-ad">
        <component 
          :is="currentAd.link?.startsWith('/') ? 'router-link' : 'a'" 
          :to="currentAd.link?.startsWith('/') ? currentAd.link : undefined" 
          :href="!currentAd.link?.startsWith('/') ? currentAd.link : undefined" 
          :target="!currentAd.link?.startsWith('/') ? '_blank' : undefined" 
          class="ad-banner"
        >
          <img :src="currentAd.imageUrl" :alt="currentAd.title" />
          <span class="ad-label">AD</span>
        </component>
      </div>

      <template v-if="userProfile?.role === 'admin'">
        <nav class="sidebar-nav admin-nav">
          <div class="nav-group">
            <div class="nav-group-header admin">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
              <span>관리자</span>
            </div>
            <div class="nav-group-items">
              <router-link to="/admin" class="nav-item" active-class="active">대시보드</router-link>
              <router-link to="/admin/point-settings" class="nav-item" active-class="active">포인트 설정</router-link>
              <router-link to="/admin/sides" class="nav-item" active-class="active">사이드 관리</router-link>
              <router-link to="/admin/banners" class="nav-item" active-class="active">배너 관리</router-link>
              <router-link to="/admin/jobs" class="nav-item" active-class="active">공고 등급 관리</router-link>
            </div>
          </div>
        </nav>
      </template>
    </aside>

    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { collection, getDocs, query, where, orderBy } from 'firebase/firestore'
import { db } from '@/services/firebase'
import { useAuth } from '@/composables/useAuth'

export default {
  name: 'MypageLayout',
  setup() {
    const { userProfile } = useAuth()
    const sidebarAds = ref([])
    const currentAdIndex = ref(0)
    let interval = null

    const currentAd = computed(() => {
      const activeAds = sidebarAds.value.filter(ad => ad.isActive)
      return activeAds[currentAdIndex.value] || null
    })

    const formatPoints = (points) => {
      return new Intl.NumberFormat('ko-KR').format(points)
    }

    const fetchSidebarAds = async () => {
      try {
        const q = query(collection(db, 'sidebarAds'), where('isActive', '==', true), orderBy('order', 'asc'))
        const snapshot = await getDocs(q)
        sidebarAds.value = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
      } catch (e) { 
        console.error('사이드바 광고 로드 실패:', e) 
      }
    }

    onMounted(async () => {
      await fetchSidebarAds()
      const activeAds = sidebarAds.value.filter(ad => ad.isActive)
      if (activeAds.length > 1) {
        interval = setInterval(() => {
          currentAdIndex.value = (currentAdIndex.value + 1) % activeAds.length
        }, 5000)
      }
    })

    onUnmounted(() => { 
      if (interval) clearInterval(interval) 
    })

    return { userProfile, currentAd, formatPoints }
  }
}
</script>

<style scoped>
.mypage-layout { 
  display: flex; 
  max-width: 1400px; 
  margin: 0 auto; 
  padding: 24px; 
  gap: 32px; 
  min-height: calc(100vh - 120px); 
}

.sidebar { 
  width: 280px; 
  flex-shrink: 0; 
}

.user-info { 
  display: flex; 
  align-items: center; 
  gap: 14px; 
  padding: 20px; 
  background: #fff; 
  border-radius: 16px; 
  box-shadow: 0 2px 8px rgba(0,0,0,0.04); 
  margin-bottom: 16px; 
}

.user-avatar { 
  width: 48px; 
  height: 48px; 
  background: #3182f6; 
  color: #fff; 
  border-radius: 50%; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  font-size: 18px; 
  font-weight: 700;
  flex-shrink: 0;
}

.user-detail { 
  flex: 1; 
  min-width: 0; 
}

.user-email { 
  font-size: 14px; 
  font-weight: 600; 
  color: #191f28; 
  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis; 
}

.user-role { 
  font-size: 12px; 
  color: #6b7684; 
}

/* 포인트 카드 */
.point-card {
  display: block;
  padding: 20px;
  background: linear-gradient(135deg, #3182f6 0%, #1b64da 100%);
  border-radius: 16px;
  margin-bottom: 16px;
  transition: transform 0.15s, box-shadow 0.15s;
}

.point-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(49, 130, 246, 0.3);
}

.point-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.point-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
}

.point-header svg {
  color: rgba(255, 255, 255, 0.6);
}

.point-amount {
  font-size: 28px;
  font-weight: 700;
  color: #fff;
}

.point-amount span {
  font-size: 18px;
  margin-left: 2px;
}

.point-sub {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.referral-code {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.15);
  padding: 4px 8px;
  border-radius: 6px;
}

/* 네비게이션 */
.sidebar-nav { 
  background: #fff; 
  border-radius: 16px; 
  box-shadow: 0 2px 8px rgba(0,0,0,0.04); 
  padding: 12px; 
  margin-bottom: 16px; 
}

/* 메뉴 그룹 */
.nav-group {
  margin-bottom: 8px;
}

.nav-group:last-child {
  margin-bottom: 0;
}

.nav-group-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 700;
  color: #8b95a1;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.nav-group-header svg {
  color: #adb5bd;
}

.nav-group-header.admin {
  color: #b45309;
}

.nav-group-header.admin svg {
  color: #f59e0b;
}

.nav-group-items {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-left: 8px;
  border-left: 2px solid #f2f4f6;
  margin-left: 18px;
}

.nav-item { 
  display: flex; 
  align-items: center; 
  gap: 10px; 
  padding: 12px 14px; 
  color: #4e5968; 
  font-size: 14px; 
  font-weight: 500; 
  border-radius: 10px; 
  transition: all 0.15s; 
}

.nav-item svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.nav-item:hover { 
  background: #f9fafb; 
  color: #191f28; 
}

.nav-item.active { 
  background: #f0f7ff; 
  color: #3182f6; 
}

/* FREE 배지 */
.free-badge {
  padding: 2px 6px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: #fff;
  font-size: 9px;
  font-weight: 800;
  border-radius: 4px;
  letter-spacing: 0.5px;
  margin-left: auto;
}

/* 문의 섹션 */
.inquiry-section { 
  background: #fff; 
  border-radius: 16px; 
  box-shadow: 0 2px 8px rgba(0,0,0,0.04); 
  padding: 20px; 
  margin-bottom: 16px; 
}

.inquiry-title { 
  font-size: 14px; 
  font-weight: 700; 
  color: #191f28; 
  margin-bottom: 12px; 
}

.inquiry-btn { 
  display: flex; 
  align-items: center; 
  gap: 10px; 
  width: 100%; 
  padding: 12px 14px; 
  border-radius: 10px; 
  font-size: 14px; 
  font-weight: 500; 
  transition: all 0.15s; 
  margin-bottom: 8px; 
}

.inquiry-btn:last-child { 
  margin-bottom: 0; 
}

.inquiry-btn.kakao { 
  background: #fee500; 
  color: #191f28; 
}

.inquiry-btn.kakao:hover { 
  background: #fdd800; 
}

.inquiry-btn.email { 
  background: #f2f4f6; 
  color: #4e5968; 
}

.inquiry-btn.email:hover { 
  background: #e5e8eb; 
  color: #191f28; 
}

/* 사이드바 광고 */
.sidebar-ad { 
  border-radius: 16px; 
  overflow: hidden; 
}

.ad-banner { 
  display: block; 
  position: relative; 
}

.ad-banner img { 
  width: 100%; 
  height: auto; 
  display: block; 
}

.ad-label { 
  position: absolute; 
  top: 8px; 
  left: 8px; 
  padding: 2px 6px; 
  background: rgba(0,0,0,0.5); 
  color: #fff; 
  font-size: 10px; 
  font-weight: 600; 
  border-radius: 4px; 
}

/* 관리자 네비게이션 */
.admin-nav { 
  background: #fffbeb; 
  border: 1px solid #fde68a; 
}

.admin-nav .nav-group-items {
  border-left-color: #fde68a;
}

.admin-nav .nav-item.active { 
  background: #fef3c7; 
  color: #b45309; 
}

/* 메인 콘텐츠 */
.main-content { 
  flex: 1; 
  min-width: 0;
  padding-top: 0;
}

/* 태블릿 */
@media (max-width: 1024px) {
  .mypage-layout { 
    flex-direction: column; 
    padding: 20px 16px; 
    gap: 20px; 
  }
  
  .sidebar { 
    width: 100%; 
  }
  
  .user-info {
    padding: 16px;
  }
  
  .point-card { 
    margin-bottom: 16px; 
  }
  
  .sidebar-nav { 
    padding: 12px; 
  }

  .nav-group {
    margin-bottom: 0;
  }

  .nav-group-header {
    display: none;
  }

  .nav-group-items {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    padding-left: 0;
    border-left: none;
    margin-left: 0;
  }
  
  .nav-item { 
    flex: 1; 
    min-width: 140px; 
    justify-content: center; 
  }
  
  .inquiry-section { 
    display: flex; 
    flex-wrap: wrap; 
    gap: 12px; 
    align-items: center; 
  }
  
  .inquiry-title { 
    width: 100%; 
    margin-bottom: 4px; 
  }
  
  .inquiry-btn { 
    flex: 1; 
    min-width: 140px; 
    margin-bottom: 0; 
  }
  
  .sidebar-ad { 
    display: none; 
  }
}

/* 모바일 */
@media (max-width: 768px) {
  .mypage-layout { 
    padding: 16px 12px; 
    gap: 16px; 
  }

  .user-info {
    padding: 14px;
    border-radius: 12px;
    margin-bottom: 12px;
  }

  .user-avatar {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }

  .user-email {
    font-size: 13px;
  }

  .point-card {
    padding: 16px;
    border-radius: 12px;
    margin-bottom: 12px;
  }

  .point-amount {
    font-size: 24px;
  }

  .point-amount span {
    font-size: 14px;
  }

  .point-sub {
    margin-top: 10px;
    padding-top: 10px;
  }

  .sidebar-nav {
    padding: 8px;
    border-radius: 12px;
    margin-bottom: 12px;
  }

  .nav-group-items {
    gap: 6px;
  }

  .nav-item {
    min-width: calc(50% - 4px);
    padding: 12px 10px;
    font-size: 13px;
    gap: 8px;
    border-radius: 8px;
  }

  .nav-item svg {
    width: 16px;
    height: 16px;
  }

  .inquiry-section {
    padding: 16px;
    border-radius: 12px;
    margin-bottom: 12px;
  }

  .inquiry-title {
    font-size: 13px;
  }

  .inquiry-btn {
    padding: 10px 12px;
    font-size: 13px;
    border-radius: 8px;
    min-width: calc(50% - 6px);
  }
}

/* 소형 모바일 */
@media (max-width: 480px) {
  .mypage-layout { 
    padding: 12px 10px; 
    gap: 12px; 
  }

  .user-info {
    gap: 10px;
  }

  .user-avatar {
    width: 36px;
    height: 36px;
    font-size: 14px;
  }

  .point-card {
    padding: 14px;
  }

  .point-label {
    font-size: 12px;
  }

  .point-amount {
    font-size: 22px;
  }

  .referral-code {
    font-size: 11px;
  }

  .nav-item {
    min-width: calc(50% - 3px);
    padding: 10px 8px;
    font-size: 12px;
    gap: 6px;
  }

  .nav-item svg {
    width: 14px;
    height: 14px;
  }

  .free-badge {
    font-size: 8px;
    padding: 2px 4px;
  }

  .inquiry-btn {
    min-width: 100%;
  }
}

/* 아이폰 SE */
@media (max-width: 375px) {
  .mypage-layout {
    padding: 10px 8px;
  }

  .point-amount {
    font-size: 20px;
  }

  .nav-item {
    font-size: 11px;
    padding: 8px 6px;
  }
}

/* 터치 디바이스 */
@media (hover: none) {
  .point-card:hover {
    transform: none;
    box-shadow: none;
  }

  .nav-item:hover {
    background: transparent;
    color: #4e5968;
  }

  .nav-item.active:hover {
    background: #f0f7ff;
    color: #3182f6;
  }

  .inquiry-btn.kakao:hover {
    background: #fee500;
  }

  .inquiry-btn.email:hover {
    background: #f2f4f6;
    color: #4e5968;
  }
}
</style>